"use client"
import { useSearchParams } from "next/navigation"
import { useRouter } from "next-nprogress-bar"
import { cn } from "@lib/util"

const ClientBtn = ({ children, url, className }: any) => {
  const searchParams = useSearchParams()
  const router = useRouter()
  const hideHeader = searchParams.get("hideHeader")
  const hideFooter = searchParams.get("hideFooter")

  const newUrl = new URL(url)
  if (hideHeader) newUrl.searchParams.set("hideHeader", hideHeader)
  if (hideFooter) newUrl.searchParams.set("hideFooter", hideFooter)
  return (
    <div
      onClick={(e) => {
        e.preventDefault()
        router.push(newUrl.href)
      }}
      className={cn(className)}
    >
      {children}
    </div>
  )
}

export default ClientBtn
